export default __webpack_public_path__ + "static/media/howtouse_plus_06_en.5f48cc58.png";